// Utility to filter out categories with c_ownerClass === 'LMN'

/**
 * Filters out categories with c_ownerClass === 'LMN' from a category object.
 * @param {object} categoryObj - The category object containing a 'categories' array.
 * @returns {object} A new category object with filtered categories.
 */
interface Category {
    c_ownerClass?: string
    [key: string]: unknown
}

interface CategoryObj {
    categories?: Category[]
    [key: string]: unknown
}

export const filterOutLMNCategories = (categoryObj: CategoryObj): CategoryObj => {
    if (!categoryObj || !Array.isArray(categoryObj.categories)) {
        return categoryObj
    }
    return {
        ...categoryObj,
        categories: categoryObj.categories.filter((cat: Category) => cat.c_ownerClass !== 'LMN')
    }
}
